import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";

// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components


import { TwitterTimelineEmbed, TwitterShareButton, TwitterFollowButton, TwitterHashtagButton, TwitterMentionButton, TwitterTweetEmbed, TwitterMomentShare, TwitterDMButton, TwitterVideoEmbed, TwitterOnAirButton } from 'react-twitter-embed';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import styles from "../../../../services/ServicesSections.module.scss";




export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
 
        
        <GridItem xs={12} sm={8} md={8}>
        <a className={classes.anchor} id="start"></a>
          <h3 className={classes.title}>Right Time, Right Place? - Measurecamp Melbourne 2020 Talk</h3>
          <p> 
          Amongst clients, friends and colleagues in the digital marketing and analytics industry there seems to be an unending stream of hype surrounding the ability to traget people with “Right time, Right place” (RTRP) advertising - especially on their mobile devices..

          <br /><br /> 

          This talk reviews the tools available to see how effective RTRP advertising is and concludes that it is indeed very effective - but is still a somewhat distant 2nd in importance to getting your messaging right in the first place. 
          <br /><br /> 
          
          </p>
 
          </GridItem>

          <GridItem xs={12} sm={10} md={10}>
                <Card
                  raised
                  //background
                  //style={{
                  //  backgroundImage: "url('/img/sections/services/google-analytics-training/1.jpg')",
                  //}}
                >
                  
                  <CardActionArea>
                    <CardMedia
                      component="iframe"
                      alt="Contemplative Reptile"
                      //className={classes.media}
                      height="500"
                      image="https://docs.google.com/presentation/d/e/2PACX-1vQODNCLCSL32-ULEqVlez5c29lrWdOeC_iEBNXKeHnFaaTlKBAU897ccyQHiDxJgIcsRluyYPS2-Zqo/embed?start=false&loop=false&delayms=3000"
                      //title="Contemplative Reptile"
                    />

                  </CardActionArea>
                </Card>  
                <p><br /><br /></p>       
              </GridItem>
          

        


      </GridContainer>
    </div>

  );
}
